export enum Notification {
  NOTIFICATION_OPEN_PANEL = 'NotificationOpenPanel',
  NOTIFICATION_CLOSE_PANEL = 'NotificationClosePanel',
  NOTIFICATION_ACTION_CLICK = 'NotificationActionClick',
  NOTIFICATION_DISMISS = 'NotificationDismiss',
  NOTIFICATION_DELETE = 'NotificationDelete',
  NOTIFICATION_DELETE_ALL = 'NotificationDeleteAll',
  NOTIFICATION_MARK_AS_READ = 'NotificationMarkAsRead',
  NOTIFICATION_MARK_AS_UNREAD = 'NotificationMarkAsUnread',
  NOTIFICATION_MARK_ALL_AS_READ = 'NotificationMarkAllAsRead',
  NOTIFICATION_MARK_ALL_AS_UNREAD = 'NotificationMarkAllAsUnread',
  NOTIFICATION_CONTEXT_MENU_OPEN = 'NotificationContextMenuOpen',
  NOTIFICATION_CONTEXT_MENU_CLOSE = 'NotificationContextMenuClose',
  NOTIFICATION_PANEL_CONTEXT_MENU_OPEN = 'NotificationPanelContextMenuOpen',
  NOTIFICATION_PANEL_CONTEXT_MENU_CLOSE = 'NotificationPanelContextMenuClose',
  NOTIFICATION_PANEL_PAGINATE_FORWARD = 'NotificationPanelPaginateForward',
  NOTIFICATION_PANEL_PAGINATE_BACKWARD = 'NotificationPanelPaginateBackward',
  NOTIFICATION_PANEL_CHANGE_TAB = 'NotificationPanelChangeTab',
  NOTIFICATION_PANEL_FILTER_BY_DATE = 'NotificationPanelFilterByDate',
  NOTIFICATION_PANEL_RESET_DATE_FILTER = 'NotificationPanelResetDateFilter',
  NOTIFICATION_PANEL_OPEN_DATE_PICKER = 'NotificationPanelOpenDatePicker',
  NOTIFICATION_PANEL_CLOSE_DATE_PICKER = 'NotificationPanelCloseDatePicker',
}
